export default function LongArrowRightGradientIcon(): JSX.Element {
  return (
    <svg
      width="66"
      height="16"
      viewBox="0 0 66 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 7C0.447715 7 0 7.44772 0 8C0 8.55228 0.447715 9 1 9V7ZM65.7071 8.70711C66.0976 8.31658 66.0976 7.68342 65.7071 7.29289L59.3431 0.928932C58.9526 0.538408 58.3195 0.538408 57.9289 0.928932C57.5384 1.31946 57.5384 1.95262 57.9289 2.34315L63.5858 8L57.9289 13.6569C57.5384 14.0474 57.5384 14.6805 57.9289 15.0711C58.3195 15.4616 58.9526 15.4616 59.3431 15.0711L65.7071 8.70711ZM1 9H65V7H1V9Z"
        fill="url(#paint0_linear_634_6065)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_634_6065"
          x1="11.7723"
          y1="8.37681"
          x2="20.1781"
          y2="26.8073"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E48F2" />
          <stop offset="1" stopColor="#8458FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
